import { render, staticRenderFns } from "./BalancesPlanDetailsAdd.vue?vue&type=template&id=77e764a9&scoped=true&"
import script from "./BalancesPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e764a9",
  null
  
)

export default component.exports